// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aT4KL","controls":"styles_controls__28leR","charLimit":"styles_charLimit__23Kee","input":"styles_input__QxLla","send":"styles_send__33abO"};